import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const LoRa = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "LoRa", url: "/lora" },
            ]}
          />
          <h1>LoRa</h1>
          <p>
            The hub for documentation on building LoRa-based solutions with
            Blues. Learn how to set up a LoRaWAN gateway, how to build your
            first project with Notecard LoRa, and more.
          </p>
        </Col>
      </Row>

      <hr />

      <Row>
        <Col>
          <h2>LoRa Guides</h2>

          <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/library-books.svg")}
              />
              <h4>Connecting to a LoRaWAN Gateway</h4>
              <p>
                A guide to setting up a LoRaWAN gateway for use with Notecard
                LoRa.
              </p>
              <TrackedLink
                href="/lora/connecting-to-a-lorawan-gateway"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notehub-guides.svg")}
              />
              <h4>Building Your First LoRa App</h4>
              <p>
                Learn how to configure multiple Notecard LoRa devices to take
                regular temperature and voltage readings, send them to the
                cloud, and visualize your data in a dashboard.
              </p>
              <TrackedLink
                href="/lora/building-your-first-lora-app"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <hr />
      <h2>LoRa Resources</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/reference.svg")} />
              <h4>LoRaWAN Quickstart</h4>
              <p>
                A quickstart tutorial for getting up and running with a Blues
                LoRaWAN Starter Kit.
              </p>
              <TrackedLink
                href="/quickstart/lorawan-quickstart"
                className="landingLink"
              >
                Start tutorial
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Notecard LoRa Datasheet</h4>
              <p>
                Detailed reference document for Notecard LoRa, including pinouts
                and hardware specifications.
              </p>
              <TrackedLink
                href="/datasheets/notecard-datasheet/note-lora-v2-1"
                className="landingLink"
              >
                Visit datasheet
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
              />
              <h4>Notecard Firmware Updates</h4>
              <p>
                A listing of all Notecard firmware versions, with instructions
                on how to update your devices.
              </p>
              <TrackedLink
                href="/notecard/notecard-firmware-updates"
                className="landingLink"
              >
                Read update guide
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </>
);

export default LoRa;
